import React from "react";
import {Component} from "react";
import { withRouter, Redirect } from "react-router";


class Calendly extends Component {
    componentDidMount() {
        const head = document.querySelector('head');
        const script = document.createElement('script');
        script.setAttribute('src',  'https://assets.calendly.com/assets/external/widget.js');
        head.appendChild(script);
//<div class="calendly-inline-widget" data-url="https://calendly.com/billing-14/xr-sales-centre" style="min-width:320px;height:630px;"></div>
        var calendlyHolder = document.getElementById("calendlyHolder");
        var divHold = calendlyHolder.parentElement;
        divHold.className = "rootClass";
        // calendlyHolder.data-url="https://calendly.com/billing-14/xr-sales-centre";
      }
    
    

    render(){
        return (
            
                <div className="calendly-inline-widget" id="calendlyHolder" data-url="https://calendly.com/team-erin/online-sales-centre-appointment-parkville-gree-clone" style={{height:'100%'}}></div>

        );
    }
};


export default Calendly;
